<template>
  <main>
    <section>
      <Header />
      <div class="landing">
        <div class="copy">
          <div class="tribe">
            <button>The Tribe</button>
          </div>
          <h1 class="animate__rubberBand animate__animated animate__repeat-2">
            Warrior Mammoth NFTs
          </h1>
          <div class="under_wm">
            <p>
              Warrior Mammoth is a collection of <span>3,333</span> Unique
              Warrior Mammoth’s with hundreds of elements inspired by the tale
              of the Warrior Mammoth.
            </p>
          </div>
          <div class="sc_first">
            <div class="sc_open">
              <button class="btn" v-on:click="connectWalletPressed">
                {{ wallet.length > 2 ? "Wallet Connected" : "Connect Wallet" }}
                <!-- Connect Wallet -->
              </button>
               
                <!--               
                 <div class="status">
          {{status}}
        </div> -->
            </div>
            <div class="side">
              <div class="join">
                <button
                  class="btn"
                  v-on:click="amount -= 1"
                  :disabled="amount <= 1"
                >
                  -
                </button>
              </div>
              <div class="join">
                <h3>{{ amount }}</h3>
              </div>

              <div class="join">
                <button
                  class="btn"
                  v-on:click="amount += 1"
                  :disabled="amount >= 2"
                >
                  +
                </button>
              </div>
            </div>
            <div class="sc_open"  >
              <button class="btn" v-on:click="onMintPressed" >
                {{ loading ? "Loading..." : "Mint a Warrior Now" }}
              </button>
              <!-- <input v-on:input="onChange" nae='amount' type="text" max="10" class="form-control custom-height mb-2" placeholder="Enter amount to mint btw 1-10" v-model="amount"/> -->
            </div>
          </div>
        </div>

        <div v-if="!ethereumInWindow">
          <message
            v-bind:link="
              this.isMobileDevice()
                ? `https://metamask.app.link/dapp/warriormammoth.com/`
                : 'https://metamask.io/download.html'
            "
          ></message>
        </div>
        <div class="wmos flex">
          <div class="img">
            <img src="../assets/temisan.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/molo.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/toni.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/temisan.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/molo.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/toni.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/temisan.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/molo.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/toni.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/temisan.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/molo.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/toni.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/temisan.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/molo.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/toni.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/temisan.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/molo.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/toni.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/temisan.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/molo.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/toni.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/temisan.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/molo.svg" alt="" />
          </div>
          <div class="img">
            <img src="../assets/toni.svg" alt="" />
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import {
  connectWallet,
  getCurrentWalletConnected,
  mintNFT,
} from "../utils/constants/interact";
// import message from './message.vue';
import Message from "./message.vue";

require("dotenv").config();

export default {
  components: { Message },
  name: "Landing",
  data() {
    return {
      loading: false,
      dappUrl: "warriormammoth.com", // TODO enter your dapp URL. For example: https://uniswap.exchange. (don't enter the "https://")
      metamaskAppDeepLink: "https://metamask.app.link/dapp/" + this.dappUrl,
      navOn: false,
      amount: 1,
      account: null,
      abi: [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[],"name":"MAX_TOKENS","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_TOKENS_PER_PURCHASE","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"baseURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"flipSaleStatus","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"isSaleActive","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_count","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_to","type":"address"},{"internalType":"uint256","name":"_reserveAmount","type":"uint256"}],"name":"reserveTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"_baseURI","type":"string"}],"name":"setBaseURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_newPrice","type":"uint256"}],"name":"setPrice","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"tokensByOwner","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"} ],
      contract: null,
      Adress: "",
      accounts: null,
      wallet: "",
      status: "Wallet has been connected, mint a warrior now",
      name: "Test Mint.",
      ethereumInWindow: false,
      description:
        "Warrior Mammoth is a collection of 3,333 Unique Warrior Mammoth’s with hundreds of elements inspired by the tale of the Warrior Mammoth.",
      url: "https://warriormammoth.mypinata.cloud/ipfs/QmXFZNNxYzyySZg6EzKxJJ3WrAduWsat6eXmk9h4RWfigu/",
    };
  },
  async mounted() {
    const { address, status } = await getCurrentWalletConnected();
    console.log({ address, status, hostname: window.location });
    // this.wallet = address;
    // this.status = status

    this.addWalletListenerr();
  },
  methods: {
    promptOpen() {
      this.navOn = !this.navOn;
    },
    mint() {
      console.log("clicked!!!");
    },
    // async addWalletListener(){
    //     if(window.ethereum){
    //         await window.ethereum.request({method: 'eth_requestAccounts'});
    //         window.web3 = new Web3(window.ethereum)
    //         this.accounts = await web3.eth.getAccounts();
    //         this.account = this.accounts[0];
    //
    //         this.contract = new web3.eth.Contract(this.abi, this.Adress)
    //     }
    //  },

    async addWalletListenerr() {
      if (window.ethereum) {
        window.ethereum.on("accountsChanged", (accounts) => {
          if (accounts.length > 0) {
            this.wallet = accounts[0];
            this.status = (
              <p class="btn">"👆🏽 Write a message in the text-field above."</p>
            );
            this.ethereumInWindow = true;
          } else {
            this.wallet = "";
            this.status = "🦊 Connect to Metamask using the top right button.";
            this.ethereumInWindow = true;
          }
        });
      } else {
        this.status = (
          <template>
            {" "}
            🦊{" "}
            <a
              target="_blank"
              href={`${
                this.isMobileDevice()
                  ? "https://metamask.app.link/dapp/warriormammoth.com"
                  : "https://metamask.io/download.html"
              }`}
            >
              You must install Metamask, a virtual Ethereum wallet, in your
              browser.
            </a>
          </template>
        );
        this.ethereumInWindow = false;
      }
    },
    async connectWalletPressed() {
      const walletResponse = await connectWallet();
      console.log(walletResponse, ["walletResponse"]);
      this.status = walletResponse.status;
      this.wallet = walletResponse.address;
      this.ethereumInWindow = walletResponse.ethereumInWindow;
      this.loading = false;
    },
    isMobileDevice() {
      return "ontouchstart" in window || "onmsgesturechange" in window;
    },
    async onMintPressed() {
      this.loading = true;
      const { success, status } = await mintNFT(
        this.url,
        this.name,
        this.description,
        this.amount
      );
      this.status = status;
      if (success) {
        this.url = "";
        this.name = "";
        this.description = "";
        this.amount = 0;
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped src="../scss/landing.scss"></style>
